// extracted by mini-css-extract-plugin
export default {"description":"V918cJ"};